<ng-template #volumeBarMaxTextTpl>
	<p>100</p>
</ng-template>

<div class="w-100 fl fl-dir-c fl-ai-fs fl-jc-fs">
	<audio
		#audio
		class="w-100 dis-none"
		[src]="$fileUrl()"
		controls
		loop
		crossorigin="use-credentials"
		(pause)="onPause()"
		(play)="onPlay()"
		(ended)="onEnded()"
		(error)="onError()"
		(onloadedmetadata)="onLoadedMetadata()"
		(durationchange)="onDurationChange()"
		(timeupdate)="onTimeUpdate()"
		(volumechange)="onVolumeChange()"
	></audio>

	<div class="w-100 h-0 ov-h fl fl-ai-c fl-jc-fs">
		<div #volumeBarMaxText>
			<ng-container [ngTemplateOutlet]="volumeBarMaxTextTpl"></ng-container>
		</div>
	</div>

	<div class="w-100 p-3-rl p-2-tb fl fl-ai-c fl-jc-c fl-gap-2 bg-280 br-1h">
		<div class="fl-fixed fl fl-ai-c fl-jc-fs fl-gap-0h">
			<button class="fc-500" commonButtonIcon (click)="togglePlay()">
				<i
					[class.icon-bold-play-media]="!$playing()"
					[class.icon-bold-pause-media]="$playing()"
				></i>
			</button>

			<button class="fc-500" commonButtonIcon (click)="goBackwards()">
				<i class="icon-bold-backward-media"></i>
			</button>

			<button class="fc-500" commonButtonIcon (click)="goForward()">
				<i class="icon-bold-forward-media"></i>
			</button>

			<div
				class="fl fl-ai-c fl-jc-fs volume-wrapper"
				[class.show-content]="$draggingVolume()"
				[class.allow-hover]="!$draggingTime()"
				[style.--aux-volume-width.px]="volumeBarMaxText.clientWidth"
			>
				<button class="fc-500" commonButtonIcon (click)="toggleMute()">
					<i [class.icon-volume]="!$muted()" [class.icon-volume-muted]="$muted()"></i>
				</button>

				<div class="fl fl-ai-c fl-jc-fs volume-content ov-h">
					<div class="fl-fixed fl fl-ai-c fl-jc-fs fl-gap-1">
						<div
							#volumeBar
							class="pos-rel h-sp-0h br-0q fl-fixed fl fl-ai-c fl-jc-fs line-230-as-bg cursor-pointer"
							style="width: calc(10 * var(--spacing))"
						>
							<div
								class="h-100 br-0q bg-primary"
								[style.width.%]="$volumeToShow()"
							></div>

							<div
								class="pos-abs h-sp-1t w-sp-1t br-circle bg-primary pe-none"
								style="top: 50%; transform: translate(-50%, -50%)"
								[style.left.%]="$volumeToShow()"
							></div>
						</div>

						<div class="fl-fixed fl fl-dir-c fl-ai-fs fl-jc-fs">
							<div class="h-0 ov-h invisible">
								<ng-container
									[ngTemplateOutlet]="volumeBarMaxTextTpl"
								></ng-container>
							</div>
							<p>{{ $volumeToShow() | number : '1.0-0' }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			#timerBar
			class="fl-adaptable h-sp-0t line-230-as-bg ov-h cursor-pointer"
			style="border-radius: calc(0.5 * 0.75 * var(--spacing))"
		>
			<div
				class="h-100 bg-primary"
				[style.width.%]="($currentTime() / $maxTime()) * 100"
				style="border-radius: calc(0.5 * 0.75 * var(--spacing))"
			></div>
		</div>

		<p class="fl-fixed">
			<span>{{ $currentTime() | audioPreviewTimestamp }}</span>
			<span>&nbsp;/&nbsp;</span>
			<span>{{ $maxTime() | audioPreviewTimestamp }}</span>
		</p>
	</div>
</div>
